/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-unused-vars */
/** @jsxRuntime classic */
/** @jsx jsx */
import React, {
  Component,
  useEffect,
  useLayoutEffect,
  useState,
  useRef,
  Fragment,
} from "react";
import { css, jsx } from "@emotion/react";
import _ from "lodash";
import BaseCustomerForm from "controllers/BaseCustomerForm";
import config from "config.js";
import log from "common/log.js";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
const axios = require("axios");

function findCommonElements(arr1, arr2) {
  return arr1.some((item) => arr2.includes(item));
}

function emailIsValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export default class Form2 extends BaseCustomerForm {
  constructor(props) {
    super(props);
    this.state = {
      owner: 6,
      name: "",
      phone: "",
      email: "",
    };
  }

  render() {
    return (
      <div className="w-full pt-4 pb-4 pr-4 pl-4 bg-gray-200">
        <div>
          <form className=" mx-auto bg-white shadow rounded">
            <div className="xl:w-full border-b border-gray-300 py-2">
              <div className="flex items-center w-11/12 mx-auto">
                <p className="text-lg text-gray-800 font-bold">
                  Đăng ký nhận tư vấn khoá Thạc Sỹ miễn phí
                </p>
                <div className="ml-2 cursor-pointer text-gray-600">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={16}
                    height={16}
                  >
                    <path
                      className="heroicon-ui"
                      d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="w-11/12 mx-auto">
              <div className="container mx-auto">
                <div className="my-4 mx-auto xl:w-full xl:mx-0">
                  <div className="xl:flex lg:flex md:flex flex-wrap justify-between">
                    <div className="xl:w-2/5 lg:w-2/5 md:w-2/5 flex flex-col mb-4">
                      <label
                        htmlFor="FirstName"
                        className="pb-2 text-sm font-bold text-gray-800"
                      >
                        Họ tên
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        required
                        id="FirstName"
                        className="border border-gray-300 pl-3 py-2 shadow-sm rounded text-sm focus:outline-none focus:border-indigo-700 text-gray-800"
                        placeholder=""
                        value={this.state.name}
                        onChange={(e) => {
                          this.setState({ name: e.target.value });
                        }}
                      />
                    </div>

                    <div className="xl:w-2/5 lg:w-2/5 md:w-2/5 flex flex-col mb-4">
                      <label
                        htmlFor="email2"
                        className="pb-2 text-sm font-bold text-gray-800"
                      >
                        Email
                      </label>
                      <div className="relative">
                        <div className="absolute text-gray-600 flex items-center px-4 border-r h-full">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-mail"
                            width={20}
                            height={20}
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" />
                            <rect x={3} y={5} width={18} height={14} rx={2} />
                            <polyline points="3 7 12 13 21 7" />
                          </svg>
                        </div>
                        <input
                          value={this.state.email}
                          onChange={(e) => {
                            this.setState({ email: e.target.value });
                          }}
                          id="email2"
                          name="email"
                          required
                          className="w-full text-gray-800 focus:outline-none  focus:border focus:border-indigo-700 font-normal py-2 flex items-center pl-16 text-sm rounded border"
                          placeholder="example@gmail.com"
                        />
                      </div>
                    </div>

                    <div className="xl:w-2/5 lg:w-2/5 md:w-2/5 flex flex-col mb-4">
                      <label
                        htmlFor="email2"
                        className="pb-2 text-sm font-bold text-gray-800"
                      >
                        Số điện thoại
                      </label>
                      <div className="relative">
                        <div className="absolute text-gray-600 flex items-center px-4 border-r h-full">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                            <path d="M15 7a2 2 0 0 1 2 2" />
                            <path d="M15 3a6 6 0 0 1 6 6" />
                          </svg>
                        </div>
                        <input
                          value={this.state.phone}
                          onChange={(e) => {
                            this.setState({ phone: e.target.value });
                          }}
                          id="phone"
                          name="phone"
                          required
                          className="w-full text-gray-800 focus:outline-none  focus:border focus:border-indigo-700 font-normal py-2 flex items-center pl-16 text-sm rounded border"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full py-2 sm:px-12 px-4 bg-gray-100 flex justify-end rounded-bl rounded-br">
              <button
                className="w-full bg-indigo-700 transition duration-150 ease-in-out hover:bg-indigo-600 rounded text-white px-12 py-2 text-lg focus:outline-none"
                type="button"
                onClick={this.handleFormSubmit}
              >
                <strong>Đăng ký</strong>
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
